import { render } from "./PartsAboutFullOrder.vue?vue&type=template&id=a595145a"
import script from "./PartsAboutFullOrder.vue?vue&type=script&lang=js"
export * from "./PartsAboutFullOrder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__